


































import Vue, { PropType } from 'vue';
import ApplicationOverviewGrid from '@/components/organisms/applicationOverviewGrid/ApplicationOverviewGrid.vue';
import PageTemplate from '@/components/templates/pageTemplate/PageTemplate.vue';
import { Pagination } from '@/api/interfaces/common/pagination';
import { ApplicationUpdateDataModel } from '@/types/app/application/applicationUpdateDataModel';
import { SpinnerState } from '@/enums/spinnerState';
import { ApplicationStatusDetail } from '@/api/interfaces/content/common/applicationStatusDetail';

export default Vue.extend({
    name: 'ApplicationOverviewTemplate',
    components: {
        PageTemplate,
        ApplicationOverviewGrid,
    },
    props: {
        applications: {
            type: Array,
            required: true,
        },
        pagination: {
            type: Object as PropType<Pagination>,
            required: true,
        },
        applicationOverviewContent: {
            type: Object,
            required: true,
        },
        enumsContent: {
            type: Object,
            required: true,
        },
        gridSpinner: {
            type: String as PropType<SpinnerState>,
            required: true,
        },
        applicationUpdateData: {
            type: Object as PropType<ApplicationUpdateDataModel>,
            default: () => new ApplicationUpdateDataModel(),
        },
        applicationStatusItems: {
            type: Object as PropType<Record<
                string,
                ApplicationStatusDetail
            > | null>,
            default: null,
        },
    },
});
